var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    ref: "moreChart",
    staticStyle: {
      width: "100%",
      height: "300px"
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };